
<!--  v-if is in case the form async fetch hasn't been received yet-->
<loading :loading="!Boolean(handler.form)">
  <template #loading>
    <collapsible-section
      :control-name="dropdownControlId"
      :id="dropdownControlId"
      :is-open="false"
      disabled
      class="collapse-item"
    >
      <template #section-header>
        <xpinner />
      </template>
    </collapsible-section>
  </template>
  <template #loaded>
    <form-field-data
      :handler="handler"
      :q="q"
      :parent-tree-context="computedChildTreeContext"
      @select="select"
    >
      <template #before-workflow-steps>
        <section-fields
          v-if="handler.usersOnly"
          :q="q"
          :handler="handler"
          :section="handler.formUserSection()"
          icon-glyph="member"
          @select="select"
          :select-additional-parameters="[handler.formUserSection().type]"
        />
      </template>

      <template #after-workflow-steps>
        <template
          v-if="!handler.usersOnly"
        >
          <!--        TODO: Alex: Process Flow: Uncomment once payment data is functional when running a process flow -->
          <!--        <form-payment-step-data-->
          <!--          :handler="handler"-->
          <!--          :q="q"-->
          <!--          @select="select"-->
          <!--          :parent-tree-context="computedChildTreeContext"-->
          <!--        />-->
          <form-submitter-data
            :handler="handler"
            :q="q"
            :level="1"
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          />
        </template>
      </template>
    </form-field-data>
  </template>
</loading>
